export const ALERT_BANNER_TYPES = ['default', 'dark', 'error', 'warn', 'success', 'gradient'];
export const ALERT_BANNER_DISPLAY_TYPES = ['banner', 'inline'];